import { useDataQuery } from '@dhis2/app-runtime'
import { useMemo } from 'react'

export const ORG_UNITS_QUERY = {
  organisationUnits: {
    resource: 'organisationUnits',
    params: {
      pageSize: 1000,
      fields: 'id,name,level,path,parent[id,name]',
      order: 'level:asc,name:asc'
    }
  },
  organisationUnitLevels: {
    resource: 'organisationUnitLevels',
    params: {
      pageSize: 1000,
      fields: 'id,level,name'
    }
  }
}

export const useOrgUnits = () => {
  const { data, loading, error } = useDataQuery(ORG_UNITS_QUERY)

  const orgUnits = useMemo(() => data?.organisationUnits?.organisationUnits || [], [data])
  const levels = useMemo(() => data?.organisationUnitLevels?.organisationUnitLevels || [], [data])

  const getOrgUnitsByLevel = (level) => 
    orgUnits.filter(unit => unit.level === level)

  const getOrgUnitsByParent = (parentId) => 
    orgUnits.filter(unit => unit.parent?.id === parentId)

  return {
    orgUnits,
    levels,
    getOrgUnitsByLevel,
    getOrgUnitsByParent,
    loading,
    error
  }
}